import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './styles.css';
import { useDatesModalAutoOpen } from './utils/useDatesModalAutoOpen';
import { Filters } from '../../../../packages/Filters';
import { checkIsHotelsSearch } from '../../../../packages/JsonQuery/utils/checkIsHotelsSearch';
import { Desktop, NotDesktop } from '../../../../packages/Responsive';
import { RedesignedFiltersPanelContainer } from '../../../FiltersMobile/containers';
import { FooterContainer } from '../../../ListingDesktop/containers/FooterContainer';
import { SidebarContainer } from '../../../ListingDesktop/containers/SidebarContainer';
import { ListingModalContainer } from '../../../ListingMobile/containers/ListingModal';
import { Map } from '../../../Map/containers/Map';
import { EListingModalMode, EOffersFetchingMode, toggleModal } from '../../actions/listingModal';
import { PageLayout } from '../../components/PageLayout';
import { useIsDesktopFiltersMicrofrontendEnabled } from '../../hooks/useIsDesktopFiltersMicrofrontendEnabled';
import { useFiltersUxfbPoll } from '../../hooks/useUxFbPoll';
import { selectIsDesktopListingAvailable, selectIsDesktopListingVisible } from '../../selectors/desktopListing';
import { selectResultsJsonQuery } from '../../selectors/results';
import { TThunkDispatch } from '../../types/redux';
import { DesktopFiltersMicrofrontend } from '../DesktopFiltersMicrofrontend';
import { FiltersContainer } from '../FiltersContainer';
import { SaveSearchButtonContainer } from '../FiltersContainer/SaveSearchButton';
import { NavigationContainer } from '../Navigation';
import { Notifications } from '../Notifications';
import { useOfferHoverApi } from '../OfferHoverProvider';
import { SaveSearchModalContainer } from '../SaveSearchModalContainer';
import { usePageOpenUxfbEvent } from './utils/useSearchListingUxfbEvent';

export function PageContainer() {
  const dispatch = useDispatch<TThunkDispatch>();
  const jsonQuery = useSelector(selectResultsJsonQuery);
  const isDesktopListingVisible = useSelector(selectIsDesktopListingVisible);
  const isDesktopListingAvailable = useSelector(selectIsDesktopListingAvailable);
  const isHotelsSearch = checkIsHotelsSearch(jsonQuery);
  const showSaveSearchButton = !isHotelsSearch;
  const { setHoveredOfferId, resetHoveredOfferId } = useOfferHoverApi();

  const isDesktopFiltersMfEnabled = useIsDesktopFiltersMicrofrontendEnabled();

  useDatesModalAutoOpen();
  useFiltersUxfbPoll();
  usePageOpenUxfbEvent();

  React.useEffect(() => {
    dispatch(
      toggleModal({ open: true, mode: EListingModalMode.HALF_SCREEN, offersFetchingMode: EOffersFetchingMode.ALL }),
    );
  }, []);

  return (
    <>
      <PageLayout
        isSidebarOpened={isDesktopListingVisible}
        footer={<FooterContainer />}
        map={<Map />}
        navigation={
          <FiltersContainer>
            <NotDesktop>
              <RedesignedFiltersPanelContainer />
            </NotDesktop>
            <Desktop>
              {isDesktopFiltersMfEnabled ? (
                <DesktopFiltersMicrofrontend />
              ) : (
                <Filters savedSearch={showSaveSearchButton && <SaveSearchButtonContainer />} />
              )}
              <NavigationContainer />
            </Desktop>
          </FiltersContainer>
        }
        sidebar={
          <FiltersContainer>
            <NotDesktop>
              <ListingModalContainer />
            </NotDesktop>
            <Desktop>
              {isDesktopListingAvailable && (
                <SidebarContainer onOfferMouseEnter={setHoveredOfferId} onOfferMouseLeave={resetHoveredOfferId} />
              )}
            </Desktop>
          </FiltersContainer>
        }
      />
      <SaveSearchModalContainer />
      <Notifications />
    </>
  );
}
